import { Icon } from "@chakra-ui/react";

export default function ArrowBack(props) {
  return (
    <Icon width="32px" height="32px" viewBox="2 2 44 44" {...props}>
      <path
        fill="currentColor"
        d="M30,15 L4.58999996,15 L9.87999998,9.70999998 L8.45999998,8.28999998 L2.87999996,13.88 C1.71018644,15.0512702 1.71018644,16.9487298 2.87999996,18.12 L8.45999998,23.71 L9.87999998,22.29 L4.58999996,17 L30,17 L30,15 Z"
        id="Style"
      />
    </Icon>
  );
}
